import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { projectSettingServicedeskRequestResolverRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingServicedeskRequestResolverRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { servicedeskResolutionManagementPageEntrypoint } from './ui/service-desk-resolution-management/servicedeskResolutionManagementPageEntrypoint.tsx';

export const projectSettingServicedeskRequestResolverRouteEntry: ReturnType<typeof createEntry> =
	createEntry(projectSettingServicedeskRequestResolverRoute, () => ({
		group: 'project-settings-servicedesk',
		ufoName: 'jsm-request-resolver-settings',
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},
		entryPoint: () =>
			fg('rename-rovo-service-to-request-resolver')
				? servicedeskResolutionManagementPageEntrypoint
				: notFoundPageEntrypoint,

		resources: [...getServiceDeskSettingsResources(), getConsolidationStateResource()],
		perfMetricKey: 'jsm-request-resolver-settings',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}));
